import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a0fe3d64&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fe3d64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0fe3d64')) {
      api.createRecord('a0fe3d64', component.options)
    } else {
      api.reload('a0fe3d64', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a0fe3d64&scoped=true&", function () {
      api.rerender('a0fe3d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tt0K076N0Toz/JS/comp/Accordion.vue"
export default component.exports